// @flow
import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import SwitchLanguageModel, { type Locales } from 'Components/utils/languages/SwitchLanguageModel';

import { themes } from './Languages.themes';

export type LanguagesProps = {
  className?: string,
  currentLocale: string,
  getTrackingData?: ?(label: string) => TrackingData,
  isActive?: boolean,
  locales: Locales,
  theme?: string,
};

export function Languages(props: LanguagesProps) {
  const {
    className,
    currentLocale = '',
    getTrackingData,
    isActive,
    locales,
    theme = 'inline',
  } = props;

  if (isEmpty(locales)) return null;

  const { thItem, thItemCurrent, thItemFirst, thLink, thRoot } = themes[theme];

  const currentLangCode = currentLocale.split('-')[0].toUpperCase();
  const languages = new SwitchLanguageModel(locales, currentLocale);

  return (
    <ul className={classnames(className, 'reset-list', thRoot)}>
      {languages.map((localeInfos = {}, idx) => {
        const isCurrentItem = currentLangCode === localeInfos.langCode;
        const label = localeInfos.moment ? localeInfos.moment.slice(0, 2) : localeInfos.label;

        return (
          <li
            key={`${localeInfos.countryCode}-${localeInfos.langCode}`}
            className={classnames(idx === 0 ? thItemFirst : thItem, {
              [`${thItemCurrent}`]: isCurrentItem,
            })}
          >
            <TrackClick
              as="a"
              aria-current={isCurrentItem}
              aria-label={`${label} ${localeInfos.languageNativeName}`}
              className={classnames('reset-anchor', thLink)}
              data-testid="Languages-link"
              href={localeInfos.url}
              lang={localeInfos.moment}
              tabIndex={isActive ? 0 : -1}
              trackingData={
                getTrackingData ? getTrackingData(localeInfos.url.replace('/?locale=', '')) : null
              }
            >
              {localeInfos.label}
            </TrackClick>
          </li>
        );
      })}
    </ul>
  );
}
